/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Benefit_SubmissionInputs */

const en_directory_promotion_benefit_submission = /** @type {(inputs: Directory_Promotion_Benefit_SubmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited tool submissions, with the same review process as Pro.`)
};

const zh_directory_promotion_benefit_submission = /** @type {(inputs: Directory_Promotion_Benefit_SubmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不限次数提交工具，审核流程与 Pro 相同。`)
};

/**
* | output |
* | --- |
* | "Unlimited tool submissions, with the same review process as Pro." |
*
* @param {Directory_Promotion_Benefit_SubmissionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_benefit_submission = /** @type {((inputs?: Directory_Promotion_Benefit_SubmissionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Benefit_SubmissionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_benefit_submission(inputs)
	return zh_directory_promotion_benefit_submission(inputs)
});
export { directory_promotion_benefit_submission as "directory.promotion.benefit_submission" }